import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { SIGN_IN, TOKEN } from '../helpers/api';

import { SHA_Encryption, decryption } from "../helpers/token"
import axios from "axios";

import { useSelector, useDispatch } from "react-redux";
import { loginAction } from '../redux/actions/actions';



function SignIn() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    async function login(e) {
        try {
            e.preventDefault();
            console.log(username);
            console.log(password);

            const payload = {
                username: username.toLowerCase(),
                password: SHA_Encryption(password)
            }

            const res = await SIGN_IN(payload)
            if (res.success) {
                (decryption(res.hash))
                    .then(userData => {
                        console.log(userData);
                        dispatch(loginAction(JSON.parse(userData)))
                        //   navigate("/")
                        window.location.href = "/"
                    })
                    .catch(err => {
                        console.log(err);
                    })
            }
            console.log(res);


        } catch (error) {
            console.log(error);
        }

    }



    return (
        <>
            <section className='signup_sec'>
                <div className="container">
                    <div className="card jc-center">
                        <h3 className='mb-5'>Sign In</h3>
                        <form onSubmit={(e) => login(e)}>
                            <div className="mb-3">
                                <label className="form-label mb-2">Username</label>
                                <input onChange={(e) => setUsername(e.target.value)} type="text" className="form-control" placeholder='Enter here' required />
                            </div>
                            <div className="mb-5">
                                <label className="form-label mb-2">Password</label>
                                <input onChange={(e) => setPassword(e.target.value)} type="password" className="form-control" placeholder='Enter here' required />
                            </div>
                            <div className="mb-3">
                                <button className="btn sign_btn">Sign In</button>
                            </div>
                            <small className='mb-3'><Link to="/reset-password">Reset Password</Link></small>
                            <small className='mb-3'><Link to="/forget-password">Forget Password ?</Link></small>
                            <small>New User? &nbsp; <Link to="/sign-up"> Create your account</Link></small>
                        </form>
                    </div>
                </div>
            </section>
        </>
    )
}

export default SignIn
